const clampFontSize = (
  min: string,
  max: string,
  fluidVw: number,
  relativeMixin = "$3"
) => {
  return `clamp(${min}, ${fluidVw}vw + ${relativeMixin}, ${max})`;
};

export { clampFontSize };
